import React, { useMemo } from 'react';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';
import { convertiUtsToDate } from '../GrapheXT/GrapheXT';

const TableauAbsoluteMinMaxDate = ({
  configuration,
  donnees,
  viewobj_json_content,
  switchAfficherModifierIntervalle,
  dimensionWidth,
  dimensionHeight,
  donneesGraphe,
}) => {
  const generateTableData = useMemo(() => {
    if (!configuration || !donnees) {
      return { data: [], layout: {} };
    }

    let layout = {
      font: { size: 14 },
      title: {
        text: configuration.title + '<br>' + configuration.subtitle,
        font: { color: '#3c3935' },
      },
      showlegend: true,
      legend: {
        orientation: 'h',
        x: 0,
        y: -0.0,
      },
      ...(viewobj_json_content?.layout || {}),
    };

    let headers_values = [];
    let headers_unit = [];
    let sensors_names = [];
    let noms_responsables = [];
    let dates_max = [];
    let values_max = [];
    let dates_min = [];
    let values_min = [];
    let values_abs_max = [];
    let dates_abs_max = [];

    for (let curve of donnees) {
      let index_sensor_name = sensors_names.indexOf(curve.sensor_name);
      let index_prefix =
        curve.prefix === '' ? -1 : headers_values.indexOf(curve.prefix);
      let index_position_in_sensor =
        curve.position_in_sensor === ''
          ? -1
          : headers_values.indexOf(curve.position_in_sensor);

      if (index_sensor_name < 0) {
        sensors_names.push(curve.sensor_name);
        noms_responsables.push(curve.name);

        for (let ind_col = 0; ind_col < headers_values.length; ind_col++) {
          values_max[ind_col] = values_max[ind_col] || [];
          values_max[ind_col].push(null);
          values_min[ind_col] = values_min[ind_col] || [];
          values_min[ind_col].push(null);
        }
      }

      index_sensor_name =
        index_sensor_name < 0 ? sensors_names.length - 1 : index_sensor_name;

      let maxIndex = curve.y.indexOf(Math.max(...curve.y));
      let maxValue = curve.y[maxIndex];
      let maxDate = curve.x[maxIndex];

      let minIndex = curve.y.indexOf(Math.min(...curve.y));
      let minValue = curve.y[minIndex];
      let minDate = curve.x[minIndex];

      if (index_prefix < 0) {
        values_max.push(new Array(sensors_names.length).fill(null));
        dates_max.push(new Array(sensors_names.length).fill(null));
        values_min.push(new Array(sensors_names.length).fill(null));
        dates_min.push(new Array(sensors_names.length).fill(null));
        values_abs_max.push(new Array(sensors_names.length).fill(null));
        dates_abs_max.push(new Array(sensors_names.length).fill(null));

        if (Math.abs(maxValue) > Math.abs(minValue)) {
          values_abs_max[values_max.length - 1][index_sensor_name] = maxValue;
          dates_abs_max[dates_max.length - 1][index_sensor_name] = maxDate;
        } else {
          values_abs_max[values_min.length - 1][index_sensor_name] = minValue;
          dates_abs_max[dates_min.length - 1][index_sensor_name] = minDate;
        }

        headers_values.push(curve.prefix || curve.position_in_sensor);
        headers_unit.push(curve.engineering_unit);
      } else {
        const targetIndex =
          index_prefix > -1 ? index_prefix : index_position_in_sensor;
        if (Math.abs(maxValue) > Math.abs(minValue)) {
          values_abs_max[targetIndex][index_sensor_name] = maxValue;
          dates_abs_max[targetIndex][index_sensor_name] = maxDate;
        } else {
          values_abs_max[targetIndex][index_sensor_name] = minValue;
          dates_abs_max[targetIndex][index_sensor_name] = minDate;
        }
      }
    }

    let entetes = [[checkMot('nom')]];
    headers_values.forEach((valeur, index) => {
      entetes.push([
        `${checkMot('max_valeur_absolu')} ${valeur} [${checkMot('date')}]`,
      ]);
      entetes.push([
        `${checkMot('max_valeur_absolu')} ${valeur} [${headers_unit[index]}]`,
      ]);
    });

    let cells_values = [];
    dates_abs_max.forEach((dates, index) => {
      cells_values.push(convertiUtsToDate(dates));
      cells_values.push(values_abs_max[index]);
    });

    const data = [
      {
        type: 'table',
        columnwidth: [6, 5, 5, 5, 5, 5, 5],
        header: {
          values: entetes,
          align: ['left', 'center'],
          line: { width: 1, color: '#000000' },
          fill: { color: '#EFB805' },
          font: { family: 'Arial', size: 17, color: 'white' },
        },
        cells: {
          values: [sensors_names, ...cells_values],
          align: ['left', 'center'],
          line: { color: '#000000' },
          font: { family: 'Arial', size: 17, color: ['#506784'] },
          height: 25,
        },
      },
    ];

    return { data, layout };
  }, [configuration, donnees, viewobj_json_content]);

  return (
    <BibliothequePlotly
      data={generateTableData.data}
      layout={{
        ...generateTableData.layout,
        responsive: true,
        ...viewobj_json_content,
      }}
      donneesGraphe={donneesGraphe}
      ouvrirPopupModifierIntervalle={switchAfficherModifierIntervalle}
      dimensionWidth={dimensionWidth}
      dimensionHeight={dimensionHeight}
      viewobj_json_content={viewobj_json_content}
    />
  );
};

export default TableauAbsoluteMinMaxDate;
